var _rect, _g, _g2, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsermanagementMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 7,
    fill: "#9D7022"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 4.47307,
    cy: 4.47307,
    r: 4.47307,
    transform: "matrix(-1 0 0 1 21.4448 18.6572)",
    fill: "url(#paint0_linear_1685_650)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8293 35.5555C24.0679 35.5555 24.2626 35.3619 24.2484 35.1238C24.1432 33.348 23.3911 31.666 22.1262 30.4011C20.7592 29.0341 18.9051 28.2661 16.9718 28.2661C15.0385 28.266 13.1844 29.034 11.8174 30.4011C10.5524 31.666 9.80041 33.3479 9.69511 35.1238C9.68099 35.3619 9.87571 35.5555 10.1143 35.5555L16.9718 35.5555L23.8293 35.5555Z",
    fill: "url(#paint1_linear_1685_650)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 4.47307,
    cy: 4.47307,
    r: 4.47307,
    transform: "matrix(-1 0 0 1 36.1836 18.6572)",
    fill: "url(#paint2_linear_1685_650)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5681 35.5555C38.8066 35.5555 39.0013 35.3619 38.9872 35.1238C38.8819 33.348 38.1299 31.666 36.865 30.4011C35.4979 29.0341 33.6438 28.2661 31.7106 28.2661C29.7773 28.266 27.9232 29.034 26.5561 30.4011C25.2912 31.666 24.5392 33.3479 24.4339 35.1238C24.4198 35.3619 24.6145 35.5555 24.853 35.5555L31.7105 35.5555L38.5681 35.5555Z",
    fill: "url(#paint3_linear_1685_650)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9624 24.2722C21.742 24.2722 19.1314 21.6616 19.1314 18.4413C19.1314 15.2209 21.742 12.6103 24.9624 12.6103C28.1827 12.6103 30.7934 15.2209 30.7934 18.4413C30.7934 21.6616 28.1827 24.2722 24.9624 24.2722ZM31.6814 28.3566C33.4635 30.2804 34.4646 32.8896 34.4646 35.6103H24.9623L15.46 35.6102C15.46 32.8896 16.4611 30.2804 18.2431 28.3566C20.0252 26.4328 22.4421 25.3521 24.9623 25.3521C27.4825 25.3521 29.8994 26.4328 31.6814 28.3566Z",
    fill: "#FFE39C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1685_650",
    x1: 4.47307,
    y1: 0,
    x2: 4.47307,
    y2: 8.94615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8D189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1685_650",
    x1: 16.9718,
    y1: 28.2661,
    x2: 16.9718,
    y2: 42.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8D189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1685_650",
    x1: 4.47307,
    y1: 0,
    x2: 4.47307,
    y2: 8.94615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8D189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1685_650",
    x1: 31.7105,
    y1: 28.2661,
    x2: 31.7105,
    y2: 42.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8D189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA51"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsermanagementMenuIcon);
export default __webpack_public_path__ + "static/media/usermanagementMenuIcon.6c57737678aed598a35817e57ce18c8c.svg";
export { ForwardRef as ReactComponent };